// Function to get image dimensions
export const getImageDimensions = (file: File): Promise<string> => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      resolve(`${img.width}x${img.height}`);
      URL.revokeObjectURL(img.src); // Clean up
    };
    img.onerror = () => {
      resolve("unknown"); // Default if we can't determine dimensions
      URL.revokeObjectURL(img.src); // Clean up
    };
    img.src = URL.createObjectURL(file);
  });
};

// Function to get video duration
export const getVideoDuration = (file: File): Promise<number> => {
  return new Promise((resolve) => {
    const video = document.createElement('video');
    video.preload = 'metadata';
    video.onloadedmetadata = () => {
      resolve(video.duration);
      URL.revokeObjectURL(video.src); // Clean up
    };
    video.onerror = () => {
      resolve(0); // Default if we can't determine duration
      URL.revokeObjectURL(video.src); // Clean up
    };
    video.src = URL.createObjectURL(file);
  });
};